import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-asset-review-dialog',
  templateUrl: './asset-review-dialog.component.html',
  styleUrls: ['./asset-review-dialog.component.scss']
})
export class AssetReviewDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<AssetReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userUuid: string }
  ) {}

  onClose(): void {
    // Store dismissal in local storage with user-specific key
    localStorage.setItem(`asset-review-dialog-dismissed-${this.data.userUuid}`, 'true');
    this.dialogRef.close('dismissed');
  }
}